import { Component, Input, OnInit } from '@angular/core';
import { NavbarService } from '../../navbar.service';

@Component({
  selector: 'app-sub-menu-up-bar',
  templateUrl: './sub-menu-up-bar.component.html',
  styleUrls: ['./sub-menu-up-bar.component.sass'],
})
export class SubMenuUpBarComponent implements OnInit {
  @Input('menu') menu: any;

  constructor(private navbarService: NavbarService) { }

  ngOnInit(): void { }

  navigateTo(route: string): void {
    this.navbarService.navigateTo(route);
  }
}
